'use client'

import { Image } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { IMAGE_BASE_URL } from '../../../constants'

type Props = {
  imageFileName: string
  reviewer: string
  country: string
  review: string
}

const SliderCard = ({ reviewer, country, review, imageFileName }: Props) => {
  const translate = useTranslate('item_verification.reviews')

  const imageUrl = `${IMAGE_BASE_URL}/${imageFileName}`

  return (
    <article className="item-verification__reviews-card">
      <div className="u-flexbox u-gap-large u-flex-wrap">
        <div className="item-verification__reviews-card-image">
          <Image
            src={`${imageUrl}.png`}
            srcset={`${imageUrl}.png 115w, ${imageUrl}@2x.png 230w`}
            sizes="115px"
            scaling={Image.Scaling.Cover}
            loading="lazy"
          />
        </div>
        <div className="u-flexbox u-flex-direction-column u-gap-small u-ui-padding-bottom-large">
          <h3 className="item-verification__reviews-card-title">
            {translate(reviewer)}
            <br />
            {translate(country)}
          </h3>
          <div className="u-flexbox">
            {/* TODO add StarFilled16 icon to @vinted/monochrome-icons and use it */}
            <Image src={`${IMAGE_BASE_URL}/star-filled-16.svg`} />
            <Image src={`${IMAGE_BASE_URL}/star-filled-16.svg`} />
            <Image src={`${IMAGE_BASE_URL}/star-filled-16.svg`} />
            <Image src={`${IMAGE_BASE_URL}/star-filled-16.svg`} />
            <Image src={`${IMAGE_BASE_URL}/star-filled-16.svg`} />
          </div>
        </div>
      </div>

      <p className="item-verification__reviews-card-review">{translate(review)}</p>
    </article>
  )
}

export default SliderCard
